if (!customElements.get('pagination-theme')) {
  class Pagination extends HTMLElement {
    constructor() {
      super();
      const id = this.dataset.section;
      this.button = this.querySelector('.load-more');
      this.grid = document.querySelector('[data-id="' + id + '"]');
      this.pagination = parseInt(this.grid?.dataset.pagination) || 12;
      this.animations_enabled = document.body.classList.contains('animations-true') && typeof gsap !== 'undefined';
      this.i = 2;
      this.remainingProducts = []; // buffer for products
    }

    connectedCallback() {
      console.log("pagination:", this.pagination);
      if (this.classList.contains('pagination-type--loadmore')) {
        this.loadMore();
      }
      if (this.classList.contains('pagination-type--infinite')) {
        this.infinite();
      }
    }

    addUrlParam(search, key) {
      let newParam = key + '=' + this.i,
        params = '?' + newParam;

      if (search) {
        params = search.replace(new RegExp('([?&])' + key + '[^&]*'), '$1' + newParam);
        if (params === search) {
          params += '&' + newParam;
        }
      }
      return params;
    }

    loadMore() {
      this.button?.addEventListener('click', (e) => {
        e.preventDefault();
        this.loadProducts();
        this.button.blur();
      });
    }

    infinite() {
      this.observer = new IntersectionObserver((entries) => {
        const entry = entries[0];
        if (entry.isIntersecting && !this.getAttribute('loading')) {
          this.loadProducts();
        }
      }, {
        rootMargin: '300px 0px', // preload before bottom
        threshold: 0.2 // less strict, smoother trigger
      });
      this.observer.observe(this);
    }

    loadProducts() {
      if (this.getAttribute('loading')) return;

      const url = document.location.pathname + this.addUrlParam(document.location.search, 'page');
      this.setAttribute('loading', true);
      this.i++;

      fetch(url)
        .then(response => response.text())
        .then((responseText) => {
          this.renderProducts(responseText, url);
          dispatchCustomEvent?.('pagination:page-changed', { url });
        })
        .catch(() => {
          this.removeAttribute('loading');
        });
    }

    renderProducts(html, url) {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const grid = doc.getElementById('product-grid');

      if (!grid) {
        if (this.observer) this.observer.unobserve(this);
        this.removeAttribute('loading');
        if (this.button) this.button.classList.add('visually-hidden');
        return;
      }

      const newProducts = Array.from(grid.querySelectorAll('.column'));
      if (newProducts.length === 0 && this.remainingProducts.length === 0) {
        if (this.observer) this.observer.unobserve(this);
        this.removeAttribute('loading');
        if (this.button) this.button.classList.add('visually-hidden');
        return;
      }

      let products = [...this.remainingProducts, ...newProducts];
      let initial = products.slice(0, this.pagination);
      let remaining = products.slice(this.pagination);
      this.remainingProducts = remaining;

      this.appendProducts(initial);
    }

    appendProducts(products) {
      if (!products.length) {
        this.removeAttribute('loading');
        return;
      }

      products.forEach(product => {
        this.grid.appendChild(product);

        product.querySelectorAll(".lazyload").forEach((img) => {
          if (typeof lazySizes !== 'undefined') {
            lazySizes.loader.unveil(img);
          }
        });
      });

      toggleWishlistButton?.();

      if (this.animations_enabled) {
        gsap.set(products, { opacity: 0, y: 30 });
        gsap.to(products, {
          duration: 0.5,
          y: 0,
          opacity: 1,
          stagger: 0.05
        });
      }

      // reset
      this.removeAttribute('loading');

      // 🔥 IMPORTANT FIX: keep loader at page bottom always
      this.grid.after(this);

      // 🔥 re-observe loader correctly
      if (this.classList.contains('pagination-type--infinite') && this.observer) {
        this.observer.observe(this);
      }
    }
  }

  customElements.define('pagination-theme', Pagination);
}